import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Add from '@pedidosya/web-fenix/icons/Add';
import Remove from '@pedidosya/web-fenix/icons/Remove';

import { onKeyDownFunction, onKeyUpFunction } from '@utils/a11y';
import Container, { SIZE } from './components/Container';
import Action from './components/Action';
import Quantity from './components/Quantity';
function ButtonCounter({
  quantity,
  onChangeQuantity,
  size,
  className,
  iconRemove,
  maxQuantity,
}) {
  const incrementValue = useCallback(
    evt => {
      evt.stopPropagation();
      const nextQuantity = quantity + 1;
      onChangeQuantity(nextQuantity);
    },
    [onChangeQuantity, quantity],
  );

  const decrementValue = useCallback(
    evt => {
      evt.stopPropagation();
      const nextQuantity = quantity - 1;
      if (nextQuantity >= 0) onChangeQuantity(nextQuantity);
    },
    [onChangeQuantity, quantity],
  );

  return (
    <Container size={size} className={className}>
      <Action
        onClick={decrementValue}
        onKeyUp={e => onKeyUpFunction(e, () => decrementValue(e))}
        onKeyDown={e => onKeyDownFunction(e, () => decrementValue(e))}
        tabIndex={0}
        aria-label={iconRemove && quantity === 1 ? 'quitar' : 'menos'}
        role="button"
      >
        {iconRemove || <Remove ariaHidden size="small" />}
      </Action>
      <Quantity aria-live="assertive" aria-valuenow={quantity}>
        {quantity}
      </Quantity>
      <Action
        onClick={incrementValue}
        onKeyUp={e => onKeyUpFunction(e, () => incrementValue(e))}
        onKeyDown={e => onKeyDownFunction(e, () => incrementValue(e))}
        tabIndex={0}
        aria-label="más"
        role="button"
      >
        <Add
          size="small"
          ariaHidden
          color={
            maxQuantity === quantity ? 'icon-color-action-disabled' : 'default'
          }
        />
      </Action>
    </Container>
  );
}

ButtonCounter.propTypes = {
  onChangeQuantity: PropTypes.func.isRequired,
  quantity: PropTypes.number,
  size: PropTypes.oneOf(Object.values(SIZE)),
  className: PropTypes.string,
  maxQuantity: PropTypes.number,
  iconRemove: PropTypes.node,
};

ButtonCounter.defaultProps = {
  quantity: 0,
  size: SIZE.LARGE,
  iconRemove: null,
  maxQuantity: null,
};

export default ButtonCounter;
